import {WidgetName} from './widget-name.enum';
import {WidgetSize} from './widget-size.enum';
import {ApplicationName} from '../../core/model/aplication-name.enum';

export class WidgetDetail {
  id: string;
  widgetName: WidgetName;
  order: number;
  size: WidgetSize;
  applicationNames: ApplicationName[];

  constructor(id: string,
              widgetName: WidgetName,
              applicationNames: ApplicationName[],
              order: number,
              size: WidgetSize) {
    this.id = id;
    this.widgetName = widgetName;
    this.applicationNames = applicationNames;
    this.order = order;
    this.size = size;
  }
}
